import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { TitleWithIcon } from '@app/core';
import {
  Participation,
  ParticipationStatus,
  useIsAdmin,
  useValidationStrategyResultsByApplicationId,
} from '@app/api';
import { useTranslation } from 'react-i18next';
import { AutomaticValidationResultItem } from './AutomaticValidationResultItem';

const useStyles = createUseStyles((theme: Theme) => ({
  list: {
    marginLeft: theme.marginBase * 4,
  },
}));

interface Props {
  participation: Participation;
  className?: string;
}

export const AutomaticValidationResults = ({
  participation,
  className,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const isAdmin = useIsAdmin();
  const declined = participation.status === ParticipationStatus.DECLINED;

  const { data: validationResults } =
    useValidationStrategyResultsByApplicationId(
      participation.mainApplicationId,
    );

  if (!(declined && participation.declinedReason) && !isAdmin) {
    return null;
  }
  if (!participation.mainApplicationId) {
    return null;
  }

  return (
    <div className={className}>
      <TitleWithIcon
        icon="ri-thumb-down-line"
        iconColor="red"
        title={t('sessions.details.monitoring.declinedReason.title')}
      />
      <p>
        {!!participation.declinedReason &&
          t(
            `sessions.details.monitoring.declinedReason.${participation.declinedReason}`,
          )}
      </p>
      <ul className={classes.list}>
        {validationResults?.map((result) => (
          <AutomaticValidationResultItem result={result} key={result.id} />
        ))}
      </ul>
    </div>
  );
};
